import postawaImage from "../../assets/POSTAWA.png";
import mowaImage from "../../assets/MOWA.png";
import gestImage from "../../assets/GEST.png";
import chodImage from "../../assets/CHOD.png";
import yellowred from "../../assets/yellow-red.png";
import yellowgreen from "../../assets/yellow-green.png";
import yellowyellow from "../../assets/yellow-yellow.png";
import yellowblue from "../../assets/yellow-blue.png";
import t, { tImage } from "../../translations";

export default [
  {
    title: t("yellow_section_one_title"),
    subSections: [
      {
        title: t("yellow_subsection_one_title"),
        description: [
          t("yellow_subsection_one_description_one"),
          t("yellow_subsection_one_description_two"),
          t("yellow_subsection_one_description_three"),
          t("yellow_subsection_one_description_four"),
          t("yellow_subsection_one_description_five"),
          t("yellow_subsection_one_description_six"),
          t("yellow_subsection_one_description_seven"),
          t("yellow_subsection_one_description_eight"),
          t("yellow_subsection_one_description_nine"),
        ],
        positionText: "right",
      },
      { image: (props) => tImage("yellow_chart", props) },
      {
        title: t("yellow_subsection_two_title"),
        description: [
          t("yellow_subsection_two_description_one"),
          t("yellow_subsection_two_description_two"),
        ],
        positionText: "right",
      },
      {
        title: t("yellow_subsection_three_title"),
        description: [t("yellow_subsection_three_description_one")],
        positionText: "right",
      },
    ],
  },
  {
    title: t("yellow_section_two_title"),
    subSections: [
      {
        title: t("yellow_subsection_two_one_title"),
        description: [
          t("yellow_subsection_two_one_description_one"),
          t("yellow_subsection_two_one_description_two"),
          t("yellow_subsection_two_one_description_three"),
        ],
        image: postawaImage,
        positionText: "right",
      },
      {
        title: t("yellow_subsection_two_two_title"),
        description: [
          t("yellow_subsection_two_two_description_one"),
          t("yellow_subsection_two_two_description_two"),
        ],
        image: chodImage,
      },
      {
        title: t("yellow_subsection_two_three_title"),
        description: [
          t("yellow_subsection_two_three_description_one"),
          t("yellow_subsection_two_three_description_two"),
          t("yellow_subsection_two_three_description_three"),
        ],
        image: gestImage,
        positionText: "right",
      },
      {
        title: t("yellow_subsection_two_four_title"),
        description: [
          t("yellow_subsection_two_four_description_one"),
          t("yellow_subsection_two_four_description_two"),
          t("yellow_subsection_two_four_description_three"),
          t("yellow_subsection_two_four_description_four"),
          t("yellow_subsection_two_four_description_five"),
          t("yellow_subsection_two_four_description_six"),
        ],
        image: mowaImage,
      },
    ],
  },
  {
    title: t("yellow_section_three_title"),
    subSections: [
      {
        title: t("yellow_subsection_three_one_title"),
        description: [
          t("yellow_subsection_three_one_description_one"),
          t("yellow_subsection_three_one_description_two"),
          t("yellow_subsection_three_one_description_three"),
        ],
        positionText: "right",
      },
      { image: (props) => tImage("yellowInStress_chart", props) },
      {
        title: t("yellow_subsection_three_two_title"),
        description: [
          t("yellow_subsection_three_two_description_one"),
          t("yellow_subsection_three_two_description_two"),
          t("yellow_subsection_three_two_description_three"),
        ],
        positionText: "right",
      },
      {
        title: t("yellow_subsection_three_three_title"),
        description: [
          t("yellow_subsection_three_three_description_one"),
          t("yellow_subsection_three_three_description_two"),
        ],
        positionText: "right",
      },
    ],
  },
  {
    title: t("yellow_section_four_title"),
    subSections: [
      {
        description1: t("yellow_subsection_four_one_description1_one"),
        description2: t("yellow_subsection_four_one_description2_two"),
      },
      { image: (props) => tImage("team_image", props) },
    ],
  },
  {
    title: t("yellow_section_five_title"),
    subSections: [
      {
        title: t("yellow_subsection_five_one_title"),
        description: t("yellow_subsection_five_one_description_one"),
        isOneAboveAnother: true,
      },
      {
        title: t("yellow_subsection_five_two_title"),
        description: [
          t("yellow_subsection_five_two_description_one"),
          t("yellow_subsection_five_two_description_two"),
          t("yellow_subsection_five_two_description_three"),
          t("yellow_subsection_five_two_description_four"),
        ],
        positionText: "right",
      },
      { image: (props) => tImage("communication_image", props) },
      {
        title: t("yellow_subsection_five_three_title"),
        description: [
          t("yellow_subsection_five_three_description_one"),
          t("yellow_subsection_five_three_description_two"),
          t("yellow_subsection_five_three_description_three"),
          t("yellow_subsection_five_three_description_four"),
          t("yellow_subsection_five_three_description_five"),
          t("yellow_subsection_five_three_description_six"),
          t("yellow_subsection_five_three_description_seven"),
        ],
      },
    ],
  },
  {
    title: t("yellow_section_six_title"),
    subSections: [
      {
        title: t("yellow_subsection_six_one_title"),
        description: true,
      },
      {
        title: t("yellow_subsection_six_two_title"),
        description: [
          t("yellow_subsection_six_two_description_one"),
          t("yellow_subsection_six_two_description_two"),
          t("yellow_subsection_six_two_description_three"),
          t("yellow_subsection_six_two_description_four"),
          t("yellow_subsection_six_two_description_five"),
          t("yellow_subsection_six_two_description_six"),
          t("yellow_subsection_six_two_description_seven"),
          t("yellow_subsection_six_two_description_eight"),
          t("yellow_subsection_six_two_description_nine"),
          t("yellow_subsection_six_two_description_ten"),
        ],
        positionText: "right",
        image: yellowred,
      },
      {
        title: t("yellow_subsection_six_three_title"),
        description: [
          t("yellow_subsection_six_three_description_one"),
          t("yellow_subsection_six_three_description_two"),
        ],
        positionText: "right",
        image: yellowyellow,
      },
      {
        title: t("yellow_subsection_six_four_title"),
        description: [
          t("yellow_subsection_six_four_description_one"),
          t("yellow_subsection_six_four_description_two"),
          t("yellow_subsection_six_four_description_three"),
          t("yellow_subsection_six_four_description_four"),
          t("yellow_subsection_six_four_description_five"),
          t("yellow_subsection_six_four_description_six"),
          t("yellow_subsection_six_four_description_seven"),
          t("yellow_subsection_six_four_description_eight"),
          t("yellow_subsection_six_four_description_nine"),
          t("yellow_subsection_six_four_description_ten"),
        ],
        positionText: "right",
        image: yellowblue,
      },
      {
        title: t("yellow_subsection_six_five_title"),
        description: [
          t("yellow_subsection_six_five_description_one"),
          t("yellow_subsection_six_five_description_two"),
          t("yellow_subsection_six_five_description_three"),
          t("yellow_subsection_six_five_description_four"),
          t("yellow_subsection_six_five_description_five"),
          t("yellow_subsection_six_five_description_six"),
          t("yellow_subsection_six_five_description_seven"),
          t("yellow_subsection_six_five_description_eight"),
          t("yellow_subsection_six_five_description_nine"),
        ],
        positionText: "right",
        image: yellowgreen,
      },
    ],
  },
];
